import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const YouTubeIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      fill="currentcolor"
      fillRule="evenodd"
      d="m20.451 15.495-7.319-4.008v8.017zm8.96-6.538c.589 2.12.589 6.538.589 6.538s0 4.418-.589 6.538c-.319 1.172-1.265 2.083-2.472 2.4C24.757 25 16 25 16 25s-8.757 0-10.94-.567c-1.206-.317-2.152-1.237-2.471-2.4C2 19.913 2 15.505 2 15.505s0-4.418.589-6.538c.319-1.172 1.265-2.083 2.472-2.4C7.243 6 16 6 16 6s8.757 0 10.94.567c1.206.317 2.152 1.228 2.471 2.4z"
      clipRule="evenodd"
    />
  </IconV2>
);

export default YouTubeIcon;
